import { Alert, Stack, Typography } from '@mui/material';
import FrontRoyalSpinner from 'FrontRoyalSpinner';
import { SectionHeading, SelectedChipList, titleWithTag } from 'ContentItemEditor';
import { playlistEditorPath } from 'Playlists';
import { streamEditorApi } from './streamEditorApi';

// Which published playlists include this course. Read-only: a playlist owns its own course list.
export default function AssociatedPlaylists({ streamId }: { streamId: string }) {
    const { data, isLoading, isError } = streamEditorApi.useGetAssociatedPlaylistsQuery(streamId);

    return (
        <Stack spacing={1}>
            <SectionHeading>Playlists</SectionHeading>

            {isLoading && <FrontRoyalSpinner className="inline" />}

            {isError && <Alert severity="error">Failed to load playlists</Alert>}

            {!isLoading && !isError && data?.length === 0 && (
                <Typography variant="body2" color="text.secondary">
                    This course is not used in any playlists.
                </Typography>
            )}

            {!isLoading && !isError && !!data?.length && (
                <SelectedChipList
                    items={data.map(playlist => ({
                        key: playlist.id,
                        label: titleWithTag(playlist),
                        href: playlistEditorPath({ playlistId: playlist.id }),
                    }))}
                />
            )}
        </Stack>
    );
}
